import React from 'react';
import { useHistory } from 'react-router-dom';

const languages = [
    { code: 'en', label: 'English' },
    { code: 'pl', label: 'Polski' },
    { code: 'it', label: 'Italiano' },
    { code: 'es', label: 'Español' },
    { code: 'el', label: 'Ελληνικά' },
    { code: 'lt', label: 'Lietuvių' },
];

const switcherLabels = {
    en: 'Change language',
    pl: 'Zmień język',
    it: 'Cambia lingua',
    es: 'Cambiar idioma',
    el: 'Αλλαγή γλώσσας',
    lt: 'Keisti kalbą',
};

export default function LanguageSwitcher({ lang, remote = false }) {
    const history = useHistory();
    const selectedLanguage = languages.some(language => language.code === lang) ? lang : 'en';
    const label = switcherLabels[selectedLanguage];

    return (
        <label className='languageSwitcher' title={label}>
            <span className='visually-hidden'>{label}</span>
            <select
                aria-label={label}
                value={selectedLanguage}
                onChange={event => history.push(remote ? `/remote-control?lang=${event.target.value}` : `/${event.target.value}`)}
            >
                {languages.map(language => (
                    <option key={language.code} value={language.code}>{language.code.toUpperCase()} - {language.label}</option>
                ))}
            </select>
        </label>
    );
}
